export const JSON_ONE41 = {
   
  
    "TOTAL_AMOUNT": "21.64",
    "TRANSFERRED_AMOUNT": "0.00",
    "TRANSACTION_FEE": "0.00",
    "GST": "0.00",
    "PENDING_PAYOUT": "21.64"
        }

